import { Trans, useTranslation } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { ColumnDd } from './ColumnDd'
import { Fld, Lbl } from './shared'

/**
 * handle the slug column source
 */
function FieldSlugColumn() {
  const { t } = useTranslation()
  const { id, value, setValue } = useCreateColumnContext()
  const selected = value.slugOptions.slugColumn

  return (
    <Fld>
      <Lbl>
        <Trans>Column</Trans>
      </Lbl>
      <ColumnDd
        id={`${id}-slug-column`}
        placeholder={t('Select Column')}
        types={[ColumnTypes.RowID, ColumnTypes.Text]}
        selected={selected}
        onChange={(opt) => {
          setValue({
            slugOptions: {
              slugColumn: opt.id,
            },
          })
        }}
      />
    </Fld>
  )
}

/**
 * handle all fields for Slug column type
 */
export default function FieldSlug() {
  return <FieldSlugColumn />
}
